<div class="modal-overlay">
    <div class="modal-content">
        <div class="modal-header">
            <span>Warning</span>
        </div>
        <div class="modal-body">
            <p>{{ message }}</p>
        </div>
        <div class="modal-buttons mb-2">
            <button class="btn btn-cancel btn-lg mr-1" (click)="onClose()">Cancel</button>
            <button class="btn btn-confirm btn-lg ml-1" (click)="onConfirm()" #confirmButton>Confirm</button>
        </div>
    </div>
</div>
